export const COUNTRIES_WITH_REGION = ['US', 'BR'];
export const phoneNumberRegex = /^[1-9]\d{5,14}$/;
export const cpfRegex = /(\d{3})\.(\d{3})\.(\d{3})-(\d{2})/;